import React from "react";
import PropTypes from "prop-types";
import { getVarsoUrl } from "../../../../common/helpers/helpers";
import {
  DATABASE_NAMES,
  DATABASE_URLS,
} from "../../../../pages/variant/components/NcbiClinvar2/constants";

function DatabaseLink({ databaseName, id }) {
  const dbUrl = DATABASE_URLS[databaseName] || "";
  const url = getVarsoUrl(dbUrl.replace("INSERT_ID", id));
  const name = DATABASE_NAMES[databaseName] || databaseName;

  return dbUrl ? (
    <a href={url} target="_blank">
      {name}
    </a>
  ) : (
    <span>{`${name}: ${id}`}</span>
  );
}

DatabaseLink.propTypes = {
  databaseName: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
};

export default DatabaseLink;
